import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getNodes } from './api';
import { getStatusBadgeClass } from './utils';

function NodesView() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['nodes'],
    queryFn: async () => {
      const response = await getNodes();
      return response.data;
    },
    refetchInterval: 30000, // Refresh every 30 seconds
  });

  if (isLoading) {
    return <div className="loading">Loading nodes...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <strong>Error loading nodes:</strong> {error.message}
      </div>
    );
  }

  const nodes = data?.items || [];

  if (nodes.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">🖥️</div>
        <p>No nodes found</p>
      </div>
    );
  }

  return (
    <div className="section">
      <div className="section-header">
        <h2>Nodes</h2>
        <button className="btn btn-secondary" onClick={() => refetch()}>
          Refresh
        </button>
      </div>

      <div className="card-grid">
        {nodes.map((node) => (
          <div key={node.name} className="card">
            <div className="card-title">
              <span>🖥️</span>
              <span>{node.name}</span>
            </div>

            <div className="card-content">
              <div className="info-row">
                <span className="info-label">Status</span>
                <span className={`badge ${getStatusBadgeClass(node.phase)}`}>
                  {node.phase}
                </span>
              </div>

              <div className="info-row">
                <span className="info-label">IP Address</span>
                <span className="info-value">
                  <code>{node.nodeIP}</code>
                </span>
              </div>

              <div className="info-row">
                <span className="info-label">VMs Running</span>
                <span className="info-value">
                  <span className="vm-count">{node.vmCount}/2</span>
                </span>
              </div>

              <div className="info-row">
                <span className="info-label">Available CPU</span>
                <span className="info-value">{node.availableCpu} cores</span>
              </div>

              <div className="info-row">
                <span className="info-label">Available Memory</span>
                <span className="info-value">{node.availableMemory}</span>
              </div>

              <div className="info-row">
                <span className="info-label">Architecture</span>
                <span className="info-value">{node.architecture}</span>
              </div>

              <div className="info-row">
                <span className="info-label">OS Version</span>
                <span className="info-value">{node.osVersion}</span>
              </div>

              {node.orkaTags && node.orkaTags.length > 0 && (
                <div className="info-row">
                  <span className="info-label">Tags</span>
                  <span className="info-value">
                    {node.orkaTags.map((tag, idx) => (
                      <span key={idx} className="badge badge-info" style={{ marginLeft: '0.25rem' }}>
                        {tag}
                      </span>
                    ))}
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NodesView;
